import { AppState } from '@/types';
import { AppAction } from '../types';
import { initialState } from '../initialState';
import { getCurrentTier } from '@/lib/tierSystem';

export function handleLoadState(action: Extract<AppAction, { type: 'LOAD_STATE' }>): AppState {
  // Merge loaded state with initialState to ensure all properties exist
  const safeLoadedState = {
    ...initialState,
    ...action.payload,
    badges: action.payload.badges || [],
    activities: action.payload.activities || [],
    // Handle token migration
    activityCredits: action.payload.activityCredits ?? 0,
    activityCounts: {
      ...initialState.activityCounts,
      ...action.payload.activityCounts
    },
    weeklyStartDate: new Date(action.payload.weeklyStartDate),
    monthlyStartDate: action.payload.monthlyStartDate ? new Date(action.payload.monthlyStartDate) : new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    currentMonthPoints: action.payload.currentMonthPoints ?? 0,
    virtualPet: action.payload.virtualPet ? {
      ...action.payload.virtualPet,
      lastFed: new Date(action.payload.virtualPet.lastFed),
      lastPlayed: new Date(action.payload.virtualPet.lastPlayed),
      lastChecked: new Date(action.payload.virtualPet.lastChecked),
      portionTimestamps: (action.payload.virtualPet.portionTimestamps || []).map((ts: any) => new Date(ts))
    } : null,
    petInteractions: action.payload.petInteractions || [],
    teamPets: action.payload.teamPets || [],
    challenges: (action.payload.challenges || []).map(challenge => ({
      ...challenge,
      startDate: new Date(challenge.startDate),
      endDate: new Date(challenge.endDate)
    })),
    activeChallenges: (action.payload.activeChallenges || []).map(challenge => ({
      ...challenge,
      startDate: new Date(challenge.startDate),
      endDate: new Date(challenge.endDate)
    })),
    // Weekly bonus tracking with defaults
    weeklyGoalStreak: action.payload.weeklyGoalStreak ?? 0,
    lastWeekGoalAchieved: action.payload.lastWeekGoalAchieved ?? false,
    weeklyBonusEarned: action.payload.weeklyBonusEarned ?? 0,
    // Recalculate tier from current points to ensure it's always correct
    currentTier: getCurrentTier(action.payload.totalPoints || 0)
  };
  return safeLoadedState;
}